/* Victoria Signs landing page: wizard, gallery, motion and video. */

  

(function () {
  var thanks = document.getElementById("thanksName");
  if (thanks) {
    try {
      var saved = sessionStorage.getItem("novaThanksName");
      if (saved) thanks.textContent = saved;
      sessionStorage.removeItem("novaThanksName");
    } catch (err) {}
  }

  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 16); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  var FINISHES = { channel: 1, metal: 1, lightbox: 1, panel: 1 };

  // --- Lead webhook (n8n -> GoHighLevel). Shopify's own email still goes out after this. ---
  var AD_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "campaign_id", "adset_id", "ad_id", "placement", "fbclid", "gclid"];
  var AD_INPUT_IDS = { utm_source: "hUtmSource", utm_medium: "hUtmMedium", utm_campaign: "hUtmCampaign", utm_term: "hUtmTerm", utm_content: "hUtmContent", campaign_id: "hCampaignId", adset_id: "hAdsetId", ad_id: "hAdId", placement: "hPlacement", fbclid: "hFbclid", gclid: "hGclid" };
  var adParams = {};
  (function captureAdParams() {
    var fromUrl = {};
    var any = false;
    try {
      var qs = new URLSearchParams(window.location.search);
      AD_PARAMS.forEach(function (key) {
        var v = qs.get(key);
        if (v) { fromUrl[key] = String(v).slice(0, 500); any = true; }
      });
    } catch (err) {}
    try {
      if (any) sessionStorage.setItem("novaAdParams", JSON.stringify(fromUrl));
      adParams = any ? fromUrl : (JSON.parse(sessionStorage.getItem("novaAdParams") || "{}") || {});
    } catch (err) { adParams = fromUrl; }
  })();
  function pageUrlClean() { return String(window.location.href).split("#")[0]; }
  var form = document.getElementById("mockup-wizard");
  if (form && document.getElementById("width")) {
    var signStyle = "";
    var signFinish = "";
    var location = "";
    var unit = "cm";
    var fileName = "";
    var logoBlob = null;
    var leadSent = false;
    var shopifyGo = false;
    var stepIndex = 0;
    var timer = null;
    var booted = false;
    var width = document.getElementById("width");
    var height = document.getElementById("height");
    var help = document.getElementById("needHelp");
    var business = document.getElementById("business");
    var logoFile = document.getElementById("logoFile");
    var drop = document.getElementById("dropZone");
    var dropName = document.getElementById("dropName");
    var dropHint = document.getElementById("dropHint");
    var nameInput = document.getElementById("name");
    var phoneInput = document.getElementById("phone");
    var emailInput = document.getElementById("email");
    var sms = document.getElementById("sms");
    var formAlert = document.getElementById("formAlert");
    var backBtn = document.getElementById("backBtn");
    var nextBtn = document.getElementById("nextBtn");
    var submitBtn = document.getElementById("submitBtn");
    var navRow = document.getElementById("navRow");
    var stepLabel = document.getElementById("stepLabel");
    var progressBar = document.getElementById("progressBar");

    function flow() {
      var steps = ["sign"];
      if (FINISHES[signStyle]) steps.push("finish");
      steps.push("location", "size", "logo", "contact");
      return steps;
    }
    function current() { return flow()[stepIndex] || "sign"; }
    function showErr(step, message) {
      var node = form.querySelector('.step-err[data-for="' + step + '"]');
      if (!node) return;
      node.hidden = !message;
      node.textContent = message || "";
    }
    function clearErrs() {
      form.querySelectorAll(".step-err").forEach(function (node) { node.hidden = true; node.textContent = ""; });
      if (formAlert) formAlert.hidden = true;
      [nameInput, phoneInput, emailInput].forEach(function (input) {
        if (input) input.classList.remove("is-invalid");
      });
    }
    function selectButtons(group, value) {
      form.querySelectorAll('[data-advance="' + group + '"]').forEach(function (btn) {
        var on = btn.getAttribute("data-value") === value;
        btn.classList.toggle("selected", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }
    function render() {
      var steps = flow();
      var cur = steps[stepIndex] || "sign";
      var total = signStyle ? steps.length : 6;
      form.querySelectorAll(".step").forEach(function (panel) {
        panel.classList.toggle("active", panel.getAttribute("data-step") === cur);
      });
      if (cur === "finish") {
        var selected = form.querySelector('[data-advance="sign"].selected');
        var label = selected ? selected.getAttribute("data-label") : "sign";
        document.getElementById("finishTitle").textContent = "Which " + label.toLowerCase().replace(" / ", " or ") + " style?";
        form.querySelectorAll(".finish-group").forEach(function (group) {
          group.hidden = group.getAttribute("data-sign") !== signStyle;
        });
      }
      stepLabel.textContent = "Step " + (stepIndex + 1) + " of " + total;
      progressBar.style.width = ((stepIndex + 1) / total * 100) + "%";
      navRow.classList.toggle("show", stepIndex > 0);
      nextBtn.hidden = !(cur === "size" || cur === "logo");
      submitBtn.hidden = cur !== "contact";
      var backToType = cur === "finish" || (cur === "location" && !FINISHES[signStyle]);
      document.getElementById("backLabel").textContent = backToType ? " Back to sign type" : " Back";
      var privacy = document.getElementById("privacyNote");
      if (privacy) privacy.hidden = cur !== "contact";
      if (booted && stepIndex > 0) {
        var target = document.getElementById("request-mockup");
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      booted = true;
    }
    function validate(step) {
      clearErrs();
      if (step === "sign" && !signStyle) { showErr("sign", "Tap one sign style to continue."); return false; }
      if (step === "finish" && !signFinish) { showErr("finish", "Tap one style to continue."); return false; }
      if (step === "location" && !location) { showErr("location", "Choose where the sign will go."); return false; }
      if (step === "logo") {
        var biz = business.value.trim();
        var ready = !!fileName || (help.checked && biz.length > 1);
        if (!ready) {
          showErr("logo", help.checked && !biz
            ? "Please enter your business name so we can design your sign."
            : 'Upload your logo, or tick "I need design help" and enter your business name.');
          return false;
        }
      }
      if (step === "contact") {
        var nameMissing = !nameInput.value.trim();
        var phoneBad = nameInput && !/^\+?[0-9 ()-]{8,22}$/.test(phoneInput.value.trim());
        var emailBad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailInput.value.trim());
        nameInput.classList.toggle("is-invalid", nameMissing);
        phoneInput.classList.toggle("is-invalid", phoneBad);
        emailInput.classList.toggle("is-invalid", emailBad);
        if (nameMissing || phoneBad || emailBad) {
          formAlert.hidden = false;
          formAlert.textContent = "Please check the highlighted fields.";
          return false;
        }
      }
      return true;
    }
    function scheduleAdvance(from, apply) {
      apply();
      clearErrs();
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var steps = flow();
        var index = steps.indexOf(from);
        if (index >= 0 && index < steps.length - 1) stepIndex = index + 1;
        render();
      }, 220);
    }
    function goNext() {
      if (!validate(current())) return;
      clearErrs();
      stepIndex = Math.min(flow().length - 1, stepIndex + 1);
      render();
    }
    function goBack() {
      if (timer) { window.clearTimeout(timer); timer = null; }
      clearErrs();
      stepIndex = Math.max(0, stepIndex - 1);
      render();
    }
    function applyLogo(file) {
      if (!file) { fileName = ""; logoBlob = null; return; }
      if (file.size > 20 * 1024 * 1024) {
        fileName = "";
        logoBlob = null;
        if (logoFile) logoFile.value = "";
        dropName.textContent = "Choose your logo file";
        dropHint.textContent = "JPG · PNG · PDF · AI · SVG";
        showErr("logo", "That file is over 20 MB. Please send a smaller one.");
        return;
      }
      fileName = file.name;
      logoBlob = file;
      help.checked = false;
      drop.classList.remove("off");
      dropName.textContent = file.name;
      dropHint.textContent = "Tap to change";
      showErr("logo", "");
    }
    function formatPhone(raw) { return raw.replace(/[^+0-9 ()-]/g, "").slice(0, 22); }
    function selectedLabel(group) {
      var btn = form.querySelector('[data-advance="' + group + '"].selected');
      return btn ? btn.getAttribute("data-label") : "";
    }
    function fillPayload() {
      var w = width.value.trim();
      var h = height.value.trim();
      var sizeText = (!w && !h)
        ? "Not provided. Mockup from logo or business name."
        : (w && h ? (w + " × " + h + " " + unit) : ((w || h) + " " + unit));
      var lines = [
        "Free mockup request",
        "Sign: " + (selectedLabel("sign") || "—"),
        "Style: " + (FINISHES[signStyle] ? (selectedLabel("finish") || "—") : "Not asked"),
        "Location: " + (selectedLabel("location") || "—"),
        "Size: " + sizeText,
        "Business: " + (business.value.trim() || "—"),
        "Design help: " + (help.checked ? "yes" : "no"),
        "Logo file: " + (fileName || "none"),
        "SMS consent: " + (sms.checked ? "yes" : "no"),
        "Phone: " + phoneInput.value.trim()
      ];
      if (fileName) lines.push("Logo file selected locally only. Please ask the customer to email the original file.");
      document.getElementById("contactBody").value = lines.join("\n");
      AD_PARAMS.forEach(function (key) {
        var el = document.getElementById(AD_INPUT_IDS[key]);
        if (!el) return;
        el.value = adParams[key] || "";
        el.disabled = !adParams[key];
      });
      var pageEl = document.getElementById("hPageUrl");
      if (pageEl) { pageEl.value = pageUrlClean(); pageEl.disabled = false; }
      document.getElementById("hSign").value = selectedLabel("sign");
      document.getElementById("hFinish").value = FINISHES[signStyle] ? selectedLabel("finish") : "Not asked";
      document.getElementById("hLocation").value = selectedLabel("location");
      document.getElementById("hSize").value = sizeText;
      document.getElementById("hBusiness").value = business.value.trim();
      document.getElementById("hHelp").value = help.checked ? "yes" : "no";
      document.getElementById("hLogo").value = fileName || "none";
      document.getElementById("hSms").value = sms.checked ? "yes" : "no";
    }

    form.querySelectorAll("[data-advance]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.getAttribute("data-advance");
        var value = btn.getAttribute("data-value");
        if (group === "sign") {
          scheduleAdvance("sign", function () {
            signStyle = value;
            signFinish = "";
            selectButtons("sign", value);
            selectButtons("finish", "");
          });
        } else if (group === "finish") {
          scheduleAdvance("finish", function () {
            signFinish = value;
            selectButtons("finish", value);
          });
        } else if (group === "location") {
          scheduleAdvance("location", function () {
            location = value;
            selectButtons("location", value);
          });
        }
      });
    });
    nextBtn.addEventListener("click", goNext);
    backBtn.addEventListener("click", goBack);
    document.querySelectorAll(".units button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        unit = btn.getAttribute("data-unit");
        document.querySelectorAll(".units button").forEach(function (other) {
          other.setAttribute("aria-pressed", other === btn ? "true" : "false");
        });
      });
    });
    drop.addEventListener("click", function () { if (!help.checked) logoFile.click(); });
    ["dragenter", "dragover"].forEach(function (type) {
      drop.addEventListener(type, function (event) {
        event.preventDefault();
        if (!help.checked) drop.classList.add("drag");
      });
    });
    drop.addEventListener("dragleave", function (event) { event.preventDefault(); drop.classList.remove("drag"); });
    drop.addEventListener("drop", function (event) {
      event.preventDefault();
      drop.classList.remove("drag");
      if (help.checked) return;
      var file = event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) applyLogo(file);
    });
    logoFile.addEventListener("change", function () { applyLogo(logoFile.files && logoFile.files[0]); });
    help.addEventListener("change", function () {
      showErr("logo", "");
      drop.classList.toggle("off", help.checked);
      if (help.checked) {
        fileName = "";
        logoBlob = null;
        logoFile.value = "";
        dropName.textContent = "Choose your logo file";
        dropHint.textContent = "JPG · PNG · PDF · AI · SVG";
      }
    });
    phoneInput.addEventListener("input", function () { phoneInput.value = formatPhone(phoneInput.value); });
    function buildLeadPayload() {
      var fd = new FormData();
      fd.append("form_name", "Free Sign Mockup");
      fd.append("first_name", nameInput.value.trim());
      fd.append("phone", phoneInput.value.trim());
      fd.append("email", emailInput.value.trim());
      fd.append("sign_type", selectedLabel("sign"));
      fd.append("sign_style", FINISHES[signStyle] ? selectedLabel("finish") : "Not asked");
      fd.append("sign_location", selectedLabel("location"));
      fd.append("width", width.value.trim());
      fd.append("height", height.value.trim());
      fd.append("size_unit", unit);
      fd.append("size_text", document.getElementById("hSize").value);
      fd.append("business_name", business.value.trim());
      fd.append("design_help", help.checked ? "yes" : "no");
      fd.append("sms_consent", sms.checked ? "yes" : "no");
      fd.append("logo_file_name", fileName || "");
      fd.append("form_summary", document.getElementById("contactBody").value);
      fd.append("page_url", pageUrlClean());
      fd.append("page_title", document.title || "");
      fd.append("referrer", document.referrer || "");
      AD_PARAMS.forEach(function (key) { fd.append(key, adParams[key] || ""); });
      var file = logoBlob || (logoFile.files && logoFile.files[0]);
      if (file && fileName && !help.checked) fd.append("logo", file, file.name);
      return fd;
    }

    form.addEventListener("submit", function (event) {
      var cur = current();
      if (cur === "size" || cur === "logo") { event.preventDefault(); goNext(); return; }
      if (cur !== "contact" || !validate("contact")) { event.preventDefault(); return; }
      if (shopifyGo) { return; }                              // our own hand-off to Shopify: let it through (keeps Shopify's spam protection working)
      if (leadSent) { event.preventDefault(); return; }       // duplicate submit while the webhook call is in flight: ignore
      event.preventDefault();
      leadSent = true;
      fillPayload();
      try { sessionStorage.setItem("novaThanksName", nameInput.value.trim()); } catch (err) {}
      submitBtn.disabled = true;
      submitBtn.textContent = "Sending…";

      shopifyGo = true;
      if (form.requestSubmit) { form.requestSubmit(); } else { shopifyGo = false; leadSent = false; submitBtn.disabled = false; formAlert.hidden = false; formAlert.textContent = 'Please use a current browser to submit your enquiry.'; }

    });
    render();
  }

  var PAGE = 6;
  var active = "all";
  var visible = PAGE;
  var cards = Array.prototype.slice.call(document.querySelectorAll(".work-card"));
  var lb = document.getElementById("lightbox");
  var lbIndex = null;
  function filtered() {
    return cards.filter(function (card) { return active === "all" || card.getAttribute("data-style") === active; });
  }
  function shown() { return filtered().slice(0, visible); }
  function renderWork() {
    var list = filtered();
    cards.forEach(function (card) { card.classList.remove("on"); });
    list.slice(0, visible).forEach(function (card) { card.classList.add("on"); });
    var more = document.getElementById("loadMore");
    if (more) more.hidden = visible >= list.length;
  }
  function closeLb() {
    lbIndex = null;
    if (lb) lb.hidden = true;
    document.body.classList.remove("lb-open");
  }
  function showLb() {
    var list = shown();
    var card = list[lbIndex];
    if (!card) return closeLb();
    var img = card.querySelector("img");
    document.getElementById("lbImg").src = img.src;
    document.getElementById("lbImg").alt = card.getAttribute("data-alt");
    document.getElementById("lbTitle").textContent = card.getAttribute("data-title");
    document.getElementById("lbStyle").textContent = card.getAttribute("data-style-label");
    document.getElementById("lbCount").textContent = (lbIndex + 1) + " / " + list.length;
    var thumbs = document.getElementById("lbThumbs");
    thumbs.innerHTML = "";
    list.forEach(function (item, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = index === lbIndex ? "on" : "";
      button.setAttribute("aria-label", "View " + item.getAttribute("data-title"));
      var thumb = document.createElement("img");
      thumb.src = item.querySelector("img").src;
      thumb.alt = "";
      button.appendChild(thumb);
      button.addEventListener("click", function () { lbIndex = index; showLb(); });
      thumbs.appendChild(button);
    });
    lb.hidden = false;
    document.body.classList.add("lb-open");
  }
  if (cards.length) {
    cards.forEach(function (card) {
      card.querySelector("button").addEventListener("click", function () {
        var list = shown();
        var index = list.indexOf(card);
        if (index >= 0) { lbIndex = index; showLb(); }
      });
    });
    document.querySelectorAll("[data-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        active = tab.getAttribute("data-tab");
        visible = PAGE;
        closeLb();
        document.querySelectorAll("[data-tab]").forEach(function (other) { other.classList.toggle("on", other === tab); });
        renderWork();
      });
    });
    var moreBtn = document.getElementById("loadMore");
    if (moreBtn) moreBtn.addEventListener("click", function () { visible += PAGE; renderWork(); });
    document.getElementById("lbClose").addEventListener("click", closeLb);
    document.getElementById("lbPrev").addEventListener("click", function (event) {
      event.stopPropagation();
      var list = shown();
      lbIndex = (lbIndex - 1 + list.length) % list.length;
      showLb();
    });
    document.getElementById("lbNext").addEventListener("click", function (event) {
      event.stopPropagation();
      var list = shown();
      lbIndex = (lbIndex + 1) % list.length;
      showLb();
    });
    lb.addEventListener("click", closeLb);
    document.getElementById("lbCard").addEventListener("click", function (event) { event.stopPropagation(); });
    window.addEventListener("keydown", function (event) {
      if (lb.hidden) return;
      if (event.key === "Escape") closeLb();
      if (event.key === "ArrowLeft") document.getElementById("lbPrev").click();
      if (event.key === "ArrowRight") document.getElementById("lbNext").click();
    });
    renderWork();
  }

  var video = document.getElementById("mainVideo");
  document.querySelectorAll(".clip").forEach(function (clip) {
    clip.addEventListener("click", function () {
      document.querySelectorAll(".clip").forEach(function (other) { other.classList.toggle("on", other === clip); });
      video.poster = clip.getAttribute("data-poster");
      video.src = clip.getAttribute("data-src");
      document.getElementById("videoLabel").textContent = clip.getAttribute("data-title");
      video.muted = true;
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
    });
  });
  if (video) {
    video.muted = true;
    var start = video.play();
    if (start && start.catch) start.catch(function () {});
  }

  document.querySelectorAll(".faq-q").forEach(function (button) {
    button.addEventListener("click", function () {
      var item = button.parentElement;
      var wasOpen = item.classList.contains("open");
      document.querySelectorAll(".faq-item").forEach(function (other) {
        other.classList.remove("open");
        other.querySelector(".faq-q").setAttribute("aria-expanded", "false");
      });
      if (!wasOpen) {
        item.classList.add("open");
        button.setAttribute("aria-expanded", "true");
      }
    });
  });
})();

  
  
;
(function(){var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(!('IntersectionObserver' in window)||reduce)return;var nodes=document.querySelectorAll('.style-sidebar,.style-gallery,.process-story,.process-journey li,.faq-side,.faq-item,.final-banner');document.documentElement.classList.add('motion-ready');var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);}});},{threshold:.08});nodes.forEach(function(n,i){n.classList.add('reveal');if(n.matches('.process-journey li'))n.classList.add('delay-'+(i%3));obs.observe(n);});})();
;
(function(){var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(!reduced)document.documentElement.classList.add('entry-motion');var progress=document.querySelector('.reading-progress i');var queued=false;function update(){queued=false;var max=document.documentElement.scrollHeight-innerHeight;progress.style.width=(max>0?Math.min(100,scrollY/max*100):0)+'%';}addEventListener('scroll',function(){if(!queued){queued=true;requestAnimationFrame(update);}},{passive:true});update();var scene=document.querySelector('.premium-scene');if(!reduced&&matchMedia('(hover:hover) and (pointer:fine)').matches){scene.addEventListener('pointermove',function(e){var r=scene.getBoundingClientRect();var x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;scene.style.transform='perspective(1100px) rotateX('+(-y*3)+'deg) rotateY('+(x*4)+'deg)';});scene.addEventListener('pointerleave',function(){scene.style.transform='';});}})();
;

(function(){
 document.querySelectorAll('.video-toggle').forEach(function(button){
  var video=document.getElementById(button.dataset.video);video.muted=true;video.loop=true;
  // Restart before the last frame, retaining native looping as a fallback.
  function restart(){video.currentTime=0;video.play().catch(sync);}
  video.addEventListener('timeupdate',function(){if(!video.paused && Number.isFinite(video.duration) && video.currentTime>=video.duration-.22)restart();});
  video.addEventListener('ended',restart);
  function sync(){button.innerHTML=video.paused?'Play <span aria-hidden="true">▶</span>':'Pause <span aria-hidden="true">Ⅱ</span>';button.setAttribute('aria-label',(video.paused?'Play':'Pause')+' manufacturing video');}
  button.addEventListener('click',function(){if(video.paused){video.play().catch(sync);}else{video.pause();}});
  video.addEventListener('play',sync);video.addEventListener('pause',sync);
  video.play().catch(sync);sync();
 });
})();

